module.exports = __webpack_public_path__ + "frontend/images/pattern/gold@2.jpg?6b53472929e6faa0cb9a31825138a560";